import React from 'react';
import {Backdrop, CircularProgress} from "@mui/material";

interface LoaderProps {
    isLoading: boolean
}

const Loader = ({isLoading}: LoaderProps) => {
    return (
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 10001 }} open={isLoading}>
            <CircularProgress color="primary" />
        </Backdrop>
    );
};

export default Loader;
